import React from 'react';
import classnames from 'classnames';
import Label from './forms/Label';
import Helptext from './FormHelptext';
export default function FormGroup({ className, label, labelHtmlFor, labelClassName, children, helptext, }) {
    return (React.createElement("div", { className: classnames(className) },
        React.createElement(Label, { htmlFor: labelHtmlFor, className: labelClassName }, label),
        children,
        helptext && React.createElement(Helptext, { className: "mt-1" }, helptext)));
}
